var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-placeholder-column col-xl-2 col-lg-3 col-md-3 col-sm-4"},[_c('div',{staticClass:"category-placeholder"},[_c('div',{staticClass:"category-placeholder__icon"}),_c('div',{staticClass:"category-placeholder__title"})])])
}]

export { render, staticRenderFns }